import { Flex } from "@chakra-ui/react";

interface CheckoutSuccessContainerProps {
  children: React.ReactNode;
}

const CheckoutSuccessContainer = ({
  children,
}: CheckoutSuccessContainerProps) => (
  <Flex
    width="100%"
    direction="column"
    justifyContent="center"
    alignItems="center"
    paddingY={8}
  >
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      paddingX={4}
      gap={4}
    >
      {children}
    </Flex>
  </Flex>
);

export default CheckoutSuccessContainer;
